import { Link } from '@tanstack/react-router'
import { ChevronDownIcon } from 'lucide-react'
import { useState } from 'react'

import {
  isTrialPlan,
  ReservedCreditsIndicator,
  useAccount,
  useSummary,
} from '@/modules/account'
import { cn, formatNumber, humanizeDate } from '@/utils'

export const Usage = () => {
  const account = useAccount()
  const summary = useSummary()
  const [showBreakdown, setShowBreakdown] = useState(false)

  if (account?.planKind === 'legacy_subscription') return
  if (isTrialPlan(account?.planKind)) return
  const isDemo = account?.planKind === 'demo'

  return (
    <div className="flex flex-col gap-1">
      {isDemo ? (
        <div>
          N <span className="text-xs">credits</span>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => setShowBreakdown((open) => !open)}
          aria-expanded={showBreakdown}
          aria-controls="credit-breakdown"
          className="flex cursor-pointer items-center justify-between py-0.5 text-left"
        >
          <span className="flex items-center gap-1.5">
            <span>
              {formatNumber(summary?.pagesCredits ?? 0)}{' '}
              <span className="text-xs">credits</span>
            </span>
            <ReservedCreditsIndicator
              reserved={summary?.pagesCreditsReserved ?? 0}
              className="text-muted-foreground"
            />
          </span>
          <ChevronDownIcon
            className={cn(
              'text-muted-foreground size-4 transition-transform',
              showBreakdown && 'rotate-180',
            )}
          />
        </button>
      )}

      {!isDemo && showBreakdown && (
        <div
          id="credit-breakdown"
          className="text-muted-foreground mt-1 flex flex-col gap-2 border-t border-slate-200 pt-2 text-xs"
        >
          <div>
            <div className="flex items-center justify-between">
              <span>Plan credits</span>
              <span className="text-foreground font-medium">
                {formatNumber(summary?.pagesCreditsRemaining ?? 0)}
              </span>
            </div>
            {summary?.pagesCreditsNextExpiry && (
              <span className="text-[11px]">
                Expires {humanizeDate(summary.pagesCreditsNextExpiry)}
              </span>
            )}
          </div>
          <div className="flex items-center justify-between">
            <span>Bundle credits</span>
            <span className="text-foreground font-medium">
              {formatNumber(summary?.pagesBundleCreditsRemaining ?? 0)}
            </span>
          </div>
        </div>
      )}

      {!isDemo && (
        <div className="flex gap-3">
          <Link
            to="/credits"
            preload="intent"
            className="text-brand cursor-pointer text-xs font-medium hover:underline"
          >
            Buy credits
          </Link>
          <Link
            to="/credits/usage"
            preload="intent"
            className="text-brand cursor-pointer text-xs font-medium hover:underline"
          >
            View usage
          </Link>
        </div>
      )}
    </div>
  )
}
